// One export entry point for Branch Summary drill-downs: same rows/cols → CSV, Excel or PDF.
import * as XLSX from 'xlsx';
import { toast } from 'sonner';
import { FileSpreadsheet, FileText } from 'lucide-react';
import { exportToCsv, slug } from '@/lib/exportCsv';
import { exportTableToPDF } from '@/lib/pdfExport';

const cell = (c, r) => (c.format ? c.format(r[c.key], r) : r[c.key] ?? '');

export function exportRows(format, { title, subtitle = '', filename, cols, rows }) {
  const name = filename || slug(title);
  if (!rows || !rows.length) { toast.info('Nothing to export for the current filters'); return false; }
  if (format === 'csv') return exportToCsv(`${name}.csv`, rows, cols);
  if (format === 'pdf') return exportTableToPDF(title, subtitle, cols.map((c) => c.label), rows.map((r) => cols.map((c) => String(cell(c, r)))), { landscape: cols.length > 6, filename: name });
  const aoa = [[title], ...(subtitle ? [[subtitle]] : []), [], cols.map((c) => c.label),
    ...rows.map((r) => cols.map((c) => { const v = cell(c, r); const n = Number(v); return v !== '' && !Number.isNaN(n) && c.numeric ? n : v; }))];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(aoa), 'Data');
  XLSX.writeFile(wb, `${name}.xlsx`);
  return true;
}

export function ExportTrio({ spec, testId, disabled }) {
  const btn = 'inline-flex items-center gap-1 rounded-full border border-border px-2 py-0.5 text-[10px] hover:bg-muted transition-colors disabled:opacity-40';
  return (
    <span className="inline-flex gap-1" data-testid={testId}>
      <button type="button" className={btn} disabled={disabled} onClick={() => exportRows('xlsx', spec())} data-testid={`${testId}-excel`}><FileSpreadsheet size={11} />Excel</button>
      <button type="button" className={btn} disabled={disabled} onClick={() => exportRows('pdf', spec())} data-testid={`${testId}-pdf`}><FileText size={11} />PDF</button>
      <button type="button" className={btn} disabled={disabled} onClick={() => exportRows('csv', spec())} data-testid={`${testId}-csv`}>CSV</button>
    </span>
  );
}

// Summary objects → two-column export rows (every numeric leaf, dotted path as label).
export function flattenSpec(title, obj, subtitle = '') {
  const rows = [];
  const walk = (o, path) => Object.entries(o || {}).forEach(([k, v]) => {
    const label = [...path, k.replace(/_/g, ' ')].join(' · ');
    if (typeof v === 'number') rows.push({ item: label, value: v });
    else if (v && typeof v === 'object' && !Array.isArray(v)) walk(v, [...path, k.replace(/_/g, ' ')]);
  });
  walk(obj, []);
  return { title, subtitle, filename: slug(title), cols: [{ key: 'item', label: 'Item' }, { key: 'value', label: 'Amount', numeric: true }], rows };
}
